const { h, render, Component } = require('preact');

class SingleActionSSAView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let btnClass = "btn-invert ssa-button " + this.props.hover
    return (
      <div class="ssa-holder">
        <a href={this.props.SSADetails.UrlForSSA} class={btnClass} data-bhw={("web2018_ssa_"+this.props.SSADetails.SSAText).replace(' ','_')}>
          {this.props.SSADetails.SSAText}
        </a>
      </div>
    );
  }
}
module.exports = SingleActionSSAView
